// Bernie
import { ClientLogger } from 'bernie-client';
import { ClientFactories, Store } from 'bernie-plugin-mobx';
import { NOOP_LOGGER } from 'bernie-logger';

// Sources
import {
  LegalSource,
  PartnerPerfSource,
  ProductSource,
  ProductV2Source,
  ProgramSource,
  PzCampaignSource,
  PzOAuthSource,
  PzSource,
  QuicklinkSource,
  UnsubscribeSource,
  UserAuthSource,
  UserSource,
} from 'sources';

// Stores
import {
  AccountDataStateStore,
  CountriesStore,
  IndustryStore,
  LegalStore,
  LinkStore,
  PartnerPerfStore,
  ProductStore,
  ProductV2Store,
  ProgramStore,
  PzCampaignStore,
  PzOAuthStore,
  PzStore,
  QuicklinkStore,
  UiStore,
  UnsubscribeStore,
  UserAuthStore,
  UserStore,
} from 'stores';

// Utils
import AffiliateHubLogger from '../util/affiliate-hub-logger';

const { getLoggerWithIdentifier } = ClientLogger;

const stores: ClientFactories = {
  countriesStore(): Store {
    return new CountriesStore({}, NOOP_LOGGER);
  },
  industries: (): Store => new IndustryStore({}, NOOP_LOGGER),
  legal: (): Store => new LegalStore(new LegalSource({})),
  link: (): Store => new LinkStore(new LinkStore({}, NOOP_LOGGER)),
  products: (): Store => new ProductStore(new ProductSource({}), {}, NOOP_LOGGER),
  productsV2: (): Store => new ProductV2Store(new ProductV2Source(), {}, NOOP_LOGGER),
  programs: (): Store => new ProgramStore(new ProgramSource([]), {}, NOOP_LOGGER),
  quicklinks: (): Store =>
    new QuicklinkStore(new QuicklinkSource(), {}, new AffiliateHubLogger(getLoggerWithIdentifier('store.quicklinks'))),
  user(): Store {
    return new UserStore(new UserSource(), {}, NOOP_LOGGER);
  },
  userAuth: (): Store =>
    new UserAuthStore(new UserAuthSource(null), {}, new AffiliateHubLogger(getLoggerWithIdentifier('store.userAuth'))),
  pzStore: (): Store => new PzStore(new PzSource(NOOP_LOGGER), {}, NOOP_LOGGER),
  pzCampaignStore: (): Store => new PzCampaignStore(new PzCampaignSource(), {}, NOOP_LOGGER),
  uiStore(): Store {
    return new UiStore({}, {}, NOOP_LOGGER);
  },
  accountDataStateStore: (): Store =>
    new AccountDataStateStore({}, new AffiliateHubLogger(getLoggerWithIdentifier('store.appBootstrap'))),
  pzOAuthStore: (): Store =>
    new PzOAuthStore(
      new PzOAuthSource(new AffiliateHubLogger(getLoggerWithIdentifier('source.pzOAuthSource'))),
      {},
      new AffiliateHubLogger(getLoggerWithIdentifier('store.pzOAuthStore')),
    ),
  partnerPerfStore: (): Store => new PartnerPerfStore(new PartnerPerfSource([], []), {}, NOOP_LOGGER),
  unsubscribeStore: ({}): Store => new UnsubscribeStore(new UnsubscribeSource(null), {}, NOOP_LOGGER),
};

export { stores };
